import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {signupError, signupSuccess} from "features/pages/account/signup/reducer";
import {getErrorFromMessage} from "services/utils/utils";
import * as Stripe from "stripe.js";
import {PaymentMethod} from "mapping/payment_method";
import {Analytics} from "services/analytics";
import {SUBSCRIPTIONS_DETAIL} from "constants.js";

export function* signupSaga({payload}) {
    try {
        const stripe = yield Stripe.StripePromise;
        const {signup, payment, invoice, type} = payload;
        const {paymentMethod} = yield call(stripe.createPaymentMethod, {
            type: "card",
            card: payment.card,
            billing_details: {
                name: `${signup.firstName} ${signup.lastName}`
            }
        });
        const stripe_data = PaymentMethod.fromStripe(paymentMethod);
        let result = yield call([api, api.signup], signup, stripe_data, invoice, type);
        if(result.data.requires_action) {
            const user_hash = result.data.user_hash;
            try {
                const { error: errorAction } = yield call(stripe.confirmCardSetup, result.data.payment_intent_client_secret);
                if(errorAction) {
                    throw errorAction;
                }
                const confirmResult = yield call([api, api.confirmUserSignup], user_hash, type);
                const data = {
                    token: confirmResult.data.token,
                    temp_password: false,
                    remember: true,
                    onboarding_done: false
                }
                Analytics.trackPurchase(SUBSCRIPTIONS_DETAIL[type].price);
                /*istanbul ignore next*/
                yield put(signupSuccess(data));
            } catch (e) {
                console.log("ERROR SCA PROCESS", e);
                yield call([api, api.cancelUserSignup], user_hash);
                yield put(signupError(getErrorFromMessage(e)));
            }
        } else {
            const data = {
                token: result.data.token,
                temp_password: false,
                remember: true,
                onboarding_done: false
            }
            Analytics.trackPurchase(SUBSCRIPTIONS_DETAIL[type].price);
            yield put(signupSuccess(data));
        }
    } catch (e) {
        console.log(e);
        yield put(signupError(getErrorFromMessage(e)));
    }
}